import propTypes from 'prop-types'
import classNames from 'classnames'
import map from 'lodash/map'
import range from 'lodash/range'


export default function Pagination(props) {
  const pages = props.pages
  const selected = props.selected
  const rangeStart = selected - 2 < 1 ? 1 : selected - 2
  const rangeEnd = selected + 2 > pages ? pages : selected + 2
  return (
    <div className={classNames(
      'border-t flex items-center justify-center',
      props.className,
    )}>
      {
        map(
          range(rangeStart, rangeEnd + 1),
          i => (
            <div
              key={`pagination_${i}_${pages}`}
              onClick={() => props.onChange(i)}
              className={classNames(
                'px-5 pt-2 pb-3 cursor-default transition-all rounded-b-full -mt-px',
                'border-b border-l border-r',
                { 'font-bold cursor-default border-disabled-200 bg-white': i === selected },
                { 'cursor-pointer hover:text-primary-600 border-transparent': i !== selected },
              )
            }>{i}</div>
          )
        )
      }
    </div>
  )
}

Pagination.propTypes = {
  pages: propTypes.number.isRequired,
  selected: propTypes.number.isRequired,
  onChange: propTypes.func.isRequired,
  clasName: propTypes.string,
}
